export const countryList = {
  title: "Lista de Países",
  line1:
    "As fases gerais do GDHM estão enumeradas abaixo, para cada país participante. As pontuações dos países nos indicadores determinam " +
    "em que fase da saúde digital um país se encontra.",
  line2:
    "Para uma análise mais detalhada de cada país, visite a página indvidual de cada país.",
  exportButtonText: "DADOS DE EXPORTAÇÃO PARA TODOS OS PAÍSES",
};
